import { render, staticRenderFns } from "./AvailabilityIndex.vue?vue&type=template&id=0c006b72"
import script from "./AvailabilityIndex.vue?vue&type=script&lang=js"
export * from "./AvailabilityIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports